import { IPlayerError } from 'src/interfaces/PlayerError';
import styles from './styles.module.scss';

export interface IOverlayErrorProps {
  error: IPlayerError;
}

const OverlayError = ({ error }: IOverlayErrorProps) => {
  return (
    <div className={styles.overlayError} data-testid='overlay-error'>
      <div className={styles.error}>
        <h1>{error.headline}</h1>
        <h2 dangerouslySetInnerHTML={{ __html: error.message }}></h2>
        <h3>
          {error.platform}-{error.code}
        </h3>
      </div>
    </div>
  );
};

export default OverlayError;
